import { render, staticRenderFns } from "./SoliStudent.vue?vue&type=template&id=b79dc4a8"
import script from "./SoliStudent.vue?vue&type=script&lang=js"
export * from "./SoliStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports